import useKlaviyoIdentify from '@lib/hooks/useKlaviyoIdentify'

// Rendered inside <SessionProvider> so useSession() has a context to read from.
// Identifies the logged-in customer in Klaviyo on every authenticated page.
export default function KlaviyoSessionSync() {
	useKlaviyoIdentify()
	return null
}
